import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-flamingo-spinner-btn',
  template: `
    <button
      #btn
      mat-button
      fxLayout="row"
      fxLayoutAlign="center center"
      [color]="color"
      style="height: 36px"
      [ngStyle]="{ width: btnWidth }"
      (click)="setWidthAndSubmit()"
      [disabled]="disabledBtn"
    >
      @if (!showSpinner) {
        <ng-content></ng-content>
      }
      @if (showSpinner) {
        <mat-progress-spinner mode="indeterminate" color="primary" diameter="18"></mat-progress-spinner>
      }
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlamingoSpinnerBtnComponent {
  @Input() showSpinner = false;
  @Input() disabledBtn = false;
  @Input() color: ThemePalette = 'accent';
  @Output() submitBtn = new EventEmitter<void>();

  @ViewChild('btn') btnElement?: MatButton;
  btnWidth = 'auto';

  setWidthAndSubmit(): void {
    this.btnWidth = this.btnElement?._elementRef.nativeElement.offsetWidth + 'px';
    this.submitBtn.emit();
  }
}
